import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, {
    CardContent,
    CardActions,
} from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import NumberFormat from 'react-number-format';
import Divider from 'material-ui/Divider';
import WhiteButton from '../Buttons/WhiteButton';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: `calc(100% - ${unit * 3}px)`,
        paddingBottom: '24px',
        paddingTop: '16px',
    },
    gridContainer: {
        margin: unit,
    },
    card: {
        boxSizing: 'content-box',
        padding: 0,
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
    },
    cardSelected: {
        border: '3px solid #ff4700',
    },
    cardTitle: {
        marginBottom: unit * 3,
    },
    cardMonthlyLabel: {
        marginBottom: unit * 3,
    },
    cardActions: {
        height: 'auto',
        padding: '16px',
        justifyContent: 'center',
        backgroundColor: '#fafafa',
    },
    cardContent: {
        padding: 0,
    },
    cardContentInner: {
        padding: unit * 2,
    },
    quickQuote: {
        padding: unit * 2,
        margin: unit * 2,
    },
    button: {
        marginLeft: unit * 2,
    },
    buttonEmail: {
        marginLeft: unit * 2,
        borderRadius: 3,
        border: 0,
        color: '#363636',
        height: 36,
        padding: '0 10px',
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.12)',
    },
});

function ProductCard(props) {
    const cardActions = props.onSelect
        ? (
            <CardActions className={props.classes.cardActions}>
                <WhiteButton
                    isSelected={props.isSelected}
                    color="secondary"
                    onClick={props.onSelect}
                >
                    {props.isSelected ? 'Selected' : 'Select'}
                </WhiteButton>
            </CardActions>
        )
        : '';
    return (
        <Card
            className={[props.classes.card, props.isSelected ? props.classes.cardSelected : ''].join(' ')}
        >
            <CardContent className={props.classes.cardContent}>
                <div className={props.classes.cardContentInner}>
                    <Typography
                        variant="title"
                        className={props.classes.cardTitle}
                    >
                        {props.product.basics.name}
                    </Typography>
                </div>
                <Divider />
                <div className={props.classes.cardContentInner}>
                    <Typography variant="subheading">
                        <NumberFormat
                            value={props.product.basics.monthlyPayment.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </Typography>
                    <Typography
                        variant="caption"
                        className={props.classes.cardMonthlyLabel}
                    >
                        Monthly repayments
                    </Typography>
                    <Grid
                        container
                        spacing={16}
                    >
                        <Grid
                            item
                            xs={12}
                            sm={6}
                        >
                            <Typography variant="subheading">
                                <NumberFormat
                                    value={(props.product.basics.rate * 100).toFixed(2)}
                                    displayType="text"
                                    thousandSeparator
                                    suffix="%"
                                />
                            </Typography>
                            <Typography variant="caption">
                                Rate
                            </Typography>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={6}
                        >
                            <Typography variant="subheading">
                                <NumberFormat
                                    value={(props.product.basics.fees * 100).toFixed(2)}
                                    displayType="text"
                                    thousandSeparator
                                    suffix="%"
                                />
                            </Typography>
                            <Typography variant="caption">
                                Fees
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </CardContent>
            {cardActions}
        </Card>
    );
}

ProductCard.defaultProps = {
    isSelected: null,
    onSelect: null,
};

ProductCard.propTypes = {
    classes: PropTypes.object.isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func,
    product: PropTypes.object.isRequired,
};

export default withStyles(styles)(ProductCard);



// WEBPACK FOOTER //
// ./src/app/common/components/FormStepper/ProductCard.js